class listingContainer extends HTMLElement {
  constructor() {
    super();

    this.loaded = this.dataset.loaded == 'true';

    let favoriteMachineParam = this.dataset.favoriteMachineParam.replaceAll(
      ' ',
      '+'
    );
    this.favoriteMachine = `filter.p.m.filter.compatibility=${favoriteMachineParam}&filter.p.m.filter.machine-xy-model=${this.dataset.favoriteMachine}`;

    this.searchBar = this.querySelector('search-bar');

    this.collection = this.dataset.collection;
    this.collectionSection = `listing_collection`;
    this.searchSection = `listing_search`;

    const urlParams = new URLSearchParams(window.location.search);
    this.type = 'product';
    this.search = '';
    this.page = 1;
    this.filters = this.dataset.favoriteMachine ? this.favoriteMachine : '';

    if (history.state) {
      this.type = history.state.type;
      this.search = history.state.search;
      this.filters = history.state.filters;
      this.page = history.state.page;
    } else if (window.location.search != '') {
      if (urlParams.get('type')) {
        this.type = urlParams.get('type');
      }

      if (urlParams.get('page')) {
        this.page = urlParams.get('page');
      }

      if (urlParams.get('q')) {
        this.search = urlParams.get('q');
      }
      
      const query = window.location.search.slice(1).split('&');

      query.forEach(param => {
        const [key, value] = param.split('=');
    
        if (key.indexOf('filter') > -1) {
          this.filters += `&${key}=${value}`;
        }
      });

      if (this.filters.charAt(0) == '&') {
        this.filters = this.filters.slice(1);
      }
    }

    this.init();
  }

  init() {
    this.setHistoryListeners();

    this.update(true);
  }

  setHistoryListeners() {
    const onHistoryChange = (event) => {
      event.preventDefault();
      const historyState = event.state;

      if (!historyState) {
        this.type = 'product';
        this.search = '';
        this.filters = this.dataset.favoriteMachine ? this.favoriteMachine : '';
        this.page = 1;
      } else {
        this.type = historyState.type;
        this.search = historyState.search;
        this.filters = historyState.filters;
        this.page = historyState.page;
      }

      this.searchBar.setSearch(this.search);

      if (this.type == 'article') {
        var toggle = this.querySelector('#facetsToggleDiagrams');

        if (toggle) {
          toggle.checked = true;
        }
      } else {
        var toggle = this.querySelector('#facetsToggleProducts');

        if (toggle) {
          toggle.checked = true;
        }
      }

      this.update(false);
    };

    window.addEventListener('popstate', onHistoryChange);
  }

  setArticleFilters() {
    var activeFilters = this.filters.split('&');

    this.querySelectorAll('[name="filter"]').forEach((input) => {
      var value = `filter=${input.value.replace(/ /g, '+')}`;

      if (activeFilters.indexOf(value) > -1) {
        input.checked = true;
      }
    });
  }

  setPage(page) {
    this.page = page;

    this.update();
  }

  setType(type) {
    this.type = type;

    this.update();
  }

  getType() {
    return this.type;
  }

  setFilters(filters) {
    this.filters = filters;

    this.update();
  }

  resetFilters() {
    this.filters = '';
  }

  resetAllFilters() {
    this.filters = '';
    this.search = '';
    this.page = 1;
  }

  setSearch(search) {
    this.search = search;

    this.update();
  }

  getSearch() {
    if (this.search != '*') {
      return this.search;
    }

    return '';
  }

  update(updateHistory = true) {
    if (this.type == 'article') {
      var activeFilters = this.filters.replace(/filter=/g, '').split('&');

      var url = `${window.location.pathname}?${
        this.search != '' ? `q=${this.search}&` : 'q=*&'
      }${this.filters != '' ? `${this.filters}&` : ''}page=${this.page}&type=${
        this.type
      }`;

      var fetchUrl = `${window.routes.search_url}?q=${
        this.search != '' ? `${this.search}+` : '*+'
      }${activeFilters.length > 0 ? `${activeFilters.join('+')}` : ''}&page=${
        this.page
      }&type=${this.type}&options[prefix]=last&section_id=${
        this.searchSection
      }`;
    } else if (this.search != '' && this.search != null) {
      var url = `${window.location.pathname}?${
        this.search != '' ? `q=${this.search}&` : 'q=*&'
      }${this.filters != '' ? `${this.filters}&` : ''}page=${this.page}&type=${
        this.type
      }`;

      var fetchUrl = `${window.routes.search_url}?q=${
        this.search != '' ? `${this.search}` : '*'
      }&${this.filters != '' ? `${this.filters}&` : ''}page=${this.page}&type=${
        this.type
      }&options[prefix]=last&section_id=${this.searchSection}`;
    } else {
      var url = `${window.location.pathname}?${this.filters}&page=${this.page}`;

      var fetchUrl = `${window.routes.collection_url}/${this.collection}?${this.filters}&page=${this.page}&section_id=${this.collectionSection}`;
    }

    if (updateHistory) {
      history.pushState(
        {
          type: this.type,
          search: this.search,
          filters: this.filters,
          page: this.page,
        },
        '',
        `${url}`
      );
    }

    this.fetchProducts(fetchUrl);
  }

  fetchProducts(fetchUrl) {
    fetch(fetchUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.updateProductGrid(html);

        if (this.type == 'article') {
          this.setArticleFilters();
        }

        this.setAttribute('data-loaded', true);
        this.loaded = true;
      });
  }

  updateProductGrid(html) {
    let openFacets = [];

    const listingContainer = html.querySelector('#ProductGridContainer');

    const listingContainerTarget = this.querySelector('#ProductGridContainer');

    const filterContainers = listingContainerTarget.querySelectorAll(
      'details[id*=Details-]'
    );

    filterContainers.forEach((item) => {
      if (item.open) {
        openFacets.push(item.id);
      }
    });

    listingContainerTarget.innerHTML = listingContainer?.innerHTML;

    listingContainerTarget
      .querySelectorAll('details[id*=Details-]')
      .forEach((item) => {
        if (openFacets.includes(item.id)) {
          item.open = true;
        }
      });
  }
}

customElements.define('listing-container', listingContainer);

class SearchBar extends HTMLElement {
  constructor() {
    super();

    this.container = this.closest('listing-container');
    this.input = this.querySelector('#ProductGridSearch');

    this.debouncedOnKeyUp = this.debounce(this.onKeyUp.bind(this), 500);
    this.input.addEventListener('keyup', this.debouncedOnKeyUp);

    this.input.value = this.container.getSearch();
  }

  setSearch(search) {
    this.input.value = search;
  }

  debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  onKeyUp(event) {
    this.container.setSearch(this.input.value);
  }
}

customElements.define('search-bar', SearchBar);

class listingToggle extends HTMLElement {
  constructor() {
    super();

    this.container = this.closest('listing-container');
    this.inputs = this.querySelectorAll('.toggle');

    this.addEventListener('input', this.toggle.bind(this));

    if (this.container.getType() == 'article') {
      this.querySelector('#facetsToggleDiagrams').checked = true;
    }
  }

  toggle(event) {
    this.container.resetFilters();
    this.container.setType(event.target.value);
  }
}

customElements.define('listing-toggle', listingToggle);

class FacetsFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.container = this.closest('listing-container');
    this.resetFiltersButton = this.querySelector('.reset-filters');

    this.onSubmit = debounce((event) => {
      this.submitHandler(event);
    }, 500);

    this.form.addEventListener('input', this.onSubmit.bind(this));
    this.resetFiltersButton?.addEventListener(
      'click',
      this.resetFilters.bind(this)
    );
  }

  submitHandler(e) {
    e.preventDefault();

    if (e.target.getAttribute('type') == 'radio') {
      var group = e.target.closest('[role="list"]');

      group.querySelectorAll(`[type='radio']`).forEach((radio) => {
        if (!radio.checked) {
          var groupValue = radio.value;

          var filterSubgroup = document.querySelector(
            `[data-parent-filter-label='${groupValue}']`
          );

          if (filterSubgroup) {
            filterSubgroup.querySelectorAll('input').forEach((input) => {
              input.checked = false;
            });
          }
        }
      });
    }

    const formData = new FormData(this.form);
    const params = new URLSearchParams(formData).toString();

    this.container.setFilters(params);
  }

  resetFilters(e) {
    console.log('reset');

    e.preventDefault();
    this.input = document.querySelector('#ProductGridSearch');

    if (this.input) {
      this.input.value = '';
    }

    this.container.resetAllFilters();
    this.container.update();
  }
}

customElements.define('facet-filters-form', FacetsFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '')
      minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

// TODO: Check this
class pageSelect extends HTMLElement {
  constructor() {
    super();

    this.container = this.closest('listing-container');
    this.paginationcontainer = this.querySelector('.pagination__list');

    this.init();
  }

  init() {
    for (const li of this.paginationcontainer.children) {
      li.addEventListener('click', this.changePage.bind(this));
    }
  }

  changePage(event) {
    event.preventDefault();
    let target = event.target.closest('[data-target-page]');
    if (target && target.dataset.targetPage) {
      let newPage = parseInt(target.dataset.targetPage, 10);
      if (!isNaN(newPage)) {
        this.container.setPage(newPage);
      } else {
        console.error('Page number is undefined or invalid.');
      }
    }
  }
}

customElements.define('page-select', pageSelect);
